import { jsx as _jsx } from "react/jsx-runtime";
import { IconTooltip } from '../IconTooltip';
import { IconTooltipSimple } from '../IconTooltipSimple';
/**
 * Help-text icon that renders icon+tooltip
 *
 * @constant
 * @type {VFC<IHelpTextProps>}
 */
export const HelpText = ({ children, role = 'tooltip', ariaLabel = 'Help text', ariaDescription, parentLabel, }) => {
    if (!children) {
        return null;
    }
    if (typeof children === 'string' || typeof children === 'number') {
        return (_jsx(IconTooltipSimple, { content: `${children}`, ariaLabel: ariaLabel, ariaDescription: ariaDescription, parentLabel: parentLabel }));
    }
    return _jsx(IconTooltip, { content: children, ariaLabel: ariaLabel, role: role });
};
